module.exports = __webpack_public_path__ + "static/img/homebanner.83a3362.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/homebanner.jpg
// module id = 9fC2
// module chunks = 9